module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAUCAYAAABbLMdoAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAC5SURBVHgBxdA9DgIhEAXgByqx3NJECloTi90byE28iR7BI3gEb8ARMPGv3cbE0lpdcTAxWsCCjU4BJHyPIQN8UxYDtYc0fk9Z3n9uTgn0kgHmlwMhh45x4Ljgqiuc6uDLfhnRJUOjGe4Q6NothmX05Ve9O7DCwekxjusoTgVYqF0sEMSxQBT7slCFwM3QseTgU96GK9RnAit/bmhabZa+Imc7SEejXP4NykUW3EDOfwwJTLLgZyDHPQBLSWUSv49K6QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/arrow2.png
// module id = oT9I
// module chunks = 36